import React, { Component } from "react";
import * as helpers from "../helpers/helpers";
import "./SidebarItemList.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMagnifyingGlass,
  faMagnifyingGlassLocation,
  faFilter,
  faRulerCombined,
  faCirclePlus,
  faPrint,
  faFileArrowDown,
  faFloppyDisk,
} from "@fortawesome/free-solid-svg-icons";

const icons = {
  search: faMagnifyingGlass,
  searchkn: faMagnifyingGlassLocation,
  filter: faFilter,
  measure: faRulerCombined,
  addData: faCirclePlus,
  print: faPrint,
  export: faFileArrowDown,
  resultsManagement: faFloppyDisk,
};

class SidebarItemList extends Component {
  constructor(props) {
    super(props);

    // BIND THIS TO THE CLICK FUNCTION
    this.buttonClick = this.buttonClick.bind(this);

    this.state = {
      components: [],
    };
  }

  buttonClick(name) {
    //PARENT HANDLES THE REST
    this.props.onTabClick(name);
  }
  componentDidMount() {
    helpers.waitForLoad("settings", Date.now(), 30, () => {
      let listItems = null;
      if (this.props.listtype === "tools") {
        let tools = window.config.sidebarToolComponents;
        listItems = tools.filter(
          (item) => item.enabled === undefined || item.enabled
        );
      } else {
        // IMPORT THEMES FROM CONFIG
        let themes = window.config.sidebarThemeComponents;
        listItems = themes.filter(
          (item) => item.enabled === undefined || item.enabled
        );
      }
      this.setState({ components: listItems });
    });
  }

  render() {
    // GET LIST OF COMPONENTS FROM CONFIG
    if (this.state.components.length === 0) return <div />;

    return (
      <div className="simcoe-sidebarlist-container">
        {
          // CREATE ITEMS FROM CONFIG
          this.state.components.map((listItem) => {
            // SKIP IF ITS DISABLED
            if (listItem.disable !== undefined && listItem.disable) return null;
            return (
              <ToolItem
                componentname={listItem.componentName}
                onClick={() =>
                  this.props.onClick(listItem.name, this.props.listtype)
                }
                key={helpers.getUID()}
                id={listItem.id}
                name={listItem.name}
                imageName={listItem.imageName}
                description={listItem.description}
              />
            );
          })
        }
      </div>
    );
  }
}

export default SidebarItemList;

// ITEM
class ToolItem extends Component {
  state = {
    icon: this.props.imageName,
  };

  render() {
    return (
      <div className="simcoe-sidebarlist-item" onClick={this.props.onClick}>
        <div className="simcoe-sidebarlist-item-iconbackground">
        <FontAwesomeIcon 
          icon={icons[this.state.icon]} 
          data-icon={this.state.icon} 
        />
        </div>
        <div className="simcoe-sidebarlist-item-text-container">
          <div className="simcoe-sidebarlist-item-text-title">
            {this.props.name}
          </div>
          <div className="simcoe-sidebarlist-item-text-description">
            {this.props.description}
          </div>
        </div>
      </div>
    );
  }
}
